
export enum PlugTypes {
  cfp = 'CFP',
  dfp = 'DFP',
  bridgeKill = 'Bridge/Kill'
}
